<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="filter-container">
        <div class="searchContainer">
          <label class="inputLabel">广告主ID：</label>
          <el-input
            v-model="advertisersQuery.account_id"
            placeholder="请输入内容"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">状态：</label>
          <el-select
            v-model="advertisersQuery.status"
            placeholder="请选择"
          >
            <el-option
              label="正常"
              value="ADSTATUS_NORMAL"
            />
            <el-option
              label="已删除"
              value="ADSTATUS_DELETED"
            />
          </el-select>
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-refresh"
          @click="handleSearchReset"
        >
          重置
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          @click="add"
        >创建</el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        class="border-gray"
        fit
        style="width: 100%; justify-content: space-between;"
      >
        <el-table-column
          prop="id"
          label="id"
          align="center"
        />
        <el-table-column
          prop="account_name"
          label="广告名称"
          align="center"
        />
        <el-table-column
          prop="account_id"
          label="广告主账户id"
          align="center"
        />
        <el-table-column
          prop="status"
          label="视频状态"
          align="center"
        />
        <el-table-column
          prop="video_id"
          label="视频id"
          align="center"
        />
        <el-table-column
          prop="preview_url"
          label="视频文件预览地址"
          align="center"
        >
          <template scope="scope">
            <!-- -->
            <video
              width="150"
              height="150"
              controls
              muted
              :src="scope.row.preview_url"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="key_frame_image_url"
          label="视频首帧缩略图地址"
          align="center"
        >
          <template scope="scope">
            <el-image
              style="width: 90px; height: 90px"
              :src="scope.row.key_frame_image_url"
              fit="cover"
              :preview-src-list="[scope.row.key_frame_image_url]"
              @click.stop="handleClickStop"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="video_profile_name"
          label="视频格式类型"
          align="center"
        />
        <el-table-column
          prop="width"
          label="视频宽度"
          align="center"
        />
        <el-table-column
          prop="height"
          label="视频高度"
          align="center"
        />
        <el-table-column
          prop="video_frames"
          label="视频帧数"
          align="center"
        />
        <el-table-column
          prop="video_bit_rate"
          label="视频码率b/s"
          align="center"
        />
        <el-table-column
          prop="audio_codec"
          label="音频格式"
          align="center"
        />
        <el-table-column
          prop="audio_bit_rate"
          label="音频码率b/s"
          align="center"
        />
        <el-table-column
          prop="file_size"
          label="视频文件大小B(byte)"
          align="center"
        />
        <el-table-column
          prop="type"
          label="视频类型"
          align="center"
        />
        <el-table-column
          prop="signature"
          label="视频文件签名"
          align="center"
        />
        <el-table-column
          prop="system_status"
          label="转码状态"
          align="center"
        />
        <el-table-column
          prop="description"
          label="视频文件描述"
          align="center"
        />

        <el-table-column
          prop="audio_sample_rate"
          label="音频采样率(hz)"
          align="center"
        />
        <el-table-column
          prop="max_keyframe_interval"
          label="关键帧的最大间隔帧数"
          align="center"
        />
        <el-table-column
          prop="min_keyframe_interval"
          label="关键帧的最小间隔帧数"
          align="center"
        />
        <el-table-column
          prop="sample_aspect_ratio"
          label="采样纵横比"
          align="center"
        />
        <el-table-column
          prop="audio_profile_name"
          label="音频格式类型"
          align="center"
        />
        <el-table-column
          prop="scan_type"
          label="扫描类型"
          align="center"
        />
        <el-table-column
          prop="image_duration_millisecond"
          label="画面时长(ms)"
          align="center"
        />
        <el-table-column
          prop="audio_duration_millisecond"
          label="音频时长(ms)"
          align="center"
        />
        <el-table-column
          prop="source_type"
          label="视频来源"
          align="center"
        />
        <el-table-column
          prop="product_outer_id"
          label="商品 id"
          align="center"
        />
        <el-table-column
          prop="source_reference_id"
          label="素材来源关联id"
          align="center"
        />
        <el-table-column
          prop="owner_account_id"
          label="素材拥有 id"
          align="center"
        />
        <el-table-column
          prop="created_time"
          label="创建时间"
          align="center"
        />
        <!-- <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="add(scope.row)"
            >创建</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <el-dialog
      title="视频素材创建"
      :visible.sync="dialogVisible"
      width="900px"
      :before-close="handleClose"
    >
      <brandDialog
        ref="add"
        @submit="submit"
      />
    </el-dialog>
  </div>
</template>

<script>
import { material_videos, material_videosCreate } from '@/api/customer.js'
import brandDialog from './components/videoDialog.vue'

import PaginationRight from '@/components/PaginationRight/index.vue'
// import detailsList from '../../customer/accountList/components/details.vue'
export default {
  name: 'AccountList',
  components: {
    PaginationRight,
    brandDialog
  },
  data() {
    return {
      tableData: [],
      search: {},
      total: null, // 数据总条数啊
      // table列表数据请求参数
      advertisersQuery: {
        account_id: null,
        status: null,
        page: 1, // 当前页码
        page_size: 10 // 广告在系统中的状态
      },
      // 枚举值请求参数
      enumerationsQuery: {
        account_id: null,
        api_name: 'account_management/advertisers'
      },
      dialogVisible: false,
      accountIdsQuery: [], // 获取用户余额的参数
      loading: false // 加载动画
    }
  },
  created() {
    this.getAdvertiserList()
  },
  methods: {
    handleClickStop() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    async submit(obj, fu) {
      await material_videosCreate(obj)
      this.$message.success('创建成功')
      setTimeout(() => {
        this.getAdvertiserList()
      }, 2 * 60 * 1000)
      this.handleClose()
      fu()
    },
    handleClose() {
      this.dialogVisible = false
    },
    add(row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.add.send(row)
      })
    },
    getAdvertiserList() {
      this.loading = true
      material_videos(this.advertisersQuery).then(res => {
        console.log('res:', res)
        this.tableData = res.data.list
        this.total = res.data.total
        this.loading = false
        console.log(22)
      })
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.authorizeURLData = null
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.advertisersQuery.page_size = data
      this.getAdvertiserList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.advertisersQuery.page = data
      this.getAdvertiserList()
    },
    // 搜索
    handleSearch() {
      this.advertisersQuery.page = 1
      this.advertisersQuery.page_size = 10
      this.getAdvertiserList()
    },
    // 重置搜索框
    handleSearchReset() {
      this.advertisersQuery = {
        account_id: null,
        status: null,
        page: 1, // 当前页码
        page_size: 10 // 广告在系统中的状态
      }
      this.getAdvertiserList()
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .block {
  justify-content: left;
}
.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 30px;
  label {
    padding-top: 10px;
    vertical-align: middle;
    font-weight: normal;
  }
  .inputLabel {
    // display: inline-block;
    width: 120px;
  }
}

.overflow {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
